import React from 'react';
import { GlassCard } from '../../ui/Card';

const PortfolioSkeleton: React.FC = () => {
    return (
        <div className="portfolio-page">
            <div className="container">
                <div className="portfolio-grid">
                    {[...Array(3)].map((_, index) => (
                        <GlassCard key={index} className="portfolio-item portfolio-skeleton">
                            <div className="skeleton-header">
                                <div className="skeleton-line skeleton-title"></div>
                                <div className="skeleton-line skeleton-period"></div>
                            </div>
                            <div className="skeleton-content">
                                <div className="skeleton-line"></div>
                                <div className="skeleton-line"></div>
                                <div className="skeleton-line skeleton-short"></div>
                            </div>
                            <div className="skeleton-results">
                                <div className="skeleton-line skeleton-title"></div>
                                <div className="skeleton-line"></div>
                                <div className="skeleton-line"></div>
                            </div>
                            <div className="skeleton-tech">
                                <div className="skeleton-line skeleton-title"></div>
                                <div className="skeleton-badges">
                                    {[...Array(5)].map((_, i) => (
                                        <div key={i} className="skeleton-badge"></div>
                                    ))}
                                </div>
                            </div>
                        </GlassCard>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PortfolioSkeleton;
